import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRouteAdmin = ({ children }) => {
  const { adminUser } = useAuth();

  if (!adminUser) {
    alert("You must log in as Admin first!");
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRouteAdmin;
